__turbopack_context__.v({
  "root": "pX-FHa_root" + " " + __turbopack_context__.i(975967)["BentoCardSizeCss"],
});
